import React, { useState } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {

  return (
    <div className='footer'>
    <p className="head-text-presentation">Contact me at my Gmail:</p> <br />
  <p className="head-text-presentation" id='contact'><span>manriqueemaa @gmail.com</span></p>
    </div>
  );
};

export default Footer